import useAppStore from "@/context/store";
import { getSeries } from "@/services";
import { getContentType } from "@/utils/getContentType";
import imageUrl from "@/utils/imageUrl";
import classNames from "classnames";
import { useCallback, useEffect, useState } from "react";
import { When } from "react-if";
import styles from "./index.module.less";

const STICKY_TOP = 24;

export default function PinSeries({ isModal, pin, onSelect }) {
  const headerHeight = useAppStore(({ headerHeight }) => headerHeight);
  const [dataSource, setDataSource] = useState([]);

  const queryAction = useCallback(async () => {
    if (!pin?.file_material?.extra?.group_ids) {
      return;
    }
    const result = await getSeries({
      group_ids: pin?.file_material?.extra?.group_ids?.join(","),
    });

    if (!result.error) {
      setDataSource(result?.pins || []);
    }
  }, [pin]);

  useEffect(() => {
    queryAction();
  }, [queryAction]);

  return (
    <When condition={dataSource.length > 1}>
      <div className={styles.container}>
        <div
          className={styles.list}
          style={{
            top: isModal ? STICKY_TOP : STICKY_TOP + headerHeight,
            maxHeight: `calc(100vh - ${
              isModal ? STICKY_TOP + 10 : STICKY_TOP + headerHeight + 10
            }px)`,
          }}
        >
          {dataSource?.map((record) => (
            <div
              className={classNames([
                styles.item,
                pin?.pin_id === record?.pin_id ? styles.active : null,
                "transparent-img-bg",
              ])}
              key={record?.pin_id}
              data-gd-expose="content_expose"
              data-gd-click="material_click"
              data-content-id={record?.pin_id}
              data-content-type={getContentType(record)}
              data-material-id={record?.file_material?.material_id}
              data-board-id={record?.board_id}
              data-file-id={record?.file_id}
              data-ext={JSON.stringify(record?.ext)}
              data-content-source="同类型素材"
              data-material-type="套系素材"
              onClick={() => onSelect(record)}
            >
              <img
                className={styles.img}
                src={imageUrl(record?.file, { width: 56 })}
                alt={record?.raw_text}
              />
            </div>
          ))}
        </div>
      </div>
    </When>
  );
}
